<div [class.top-container-wrapper]="!componentData?.useBottomSheet">
  <div class="top-container">
    <h1 class="product-name-title">
      <span [innerHTML]="(customisableVariables$ | async)?.product_name"></span>
    </h1>
    <p [translate]="'TermsPopup:SubTitle'" class="top-container__subtitle">
      Please complete your profile to gain full access to the service.
    </p>
  </div>
  <div class="divider"></div>
  <div class="bottom-container">
    <form [formGroup]="profileFormGroup">
      <div class="title-container" *ngIf="needsTitle || needEmail">
        <p
          [translate]="
            componentData?.showCreditSaisonPotags ? 'TermsPopup:MemberProfileFormHeader' : 'TermsPopup:MissingTitle'
          "
        ></p>
        <mat-form-field>
          <mat-select [placeholder]="'TravellerFormComponent:Title' | translate" formControlName="title">
            <mat-option [value]="'Mr'"><span [translate]="'TravellerFormComponent:TitleMr'">Mr</span></mat-option>
            <mat-option [value]="'Mrs'"><span [translate]="'TravellerFormComponent:TitleMrs'">Mrs</span></mat-option>
            <mat-option [value]="'Miss'"><span [translate]="'TravellerFormComponent:TitleMiss'">Miss</span></mat-option>
            <mat-option [value]="'Ms'"><span [translate]="'TravellerFormComponent:TitleMs'">Ms</span></mat-option>
          </mat-select>
          <mat-error
            [translate]="'TravellerFormComponent:SelectGenderLabelMsg'"
            ngxErrors="title"
            ngxError="required"
            when="touched"
            role="alert"
          >
            Please select a title
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="componentData?.showFirstName">
          <input
            matInput
            [placeholder]="'TravellerFormComponent:FormFirstNameLabel' | translate"
            readonly
            [value]="data.firstName"
          />
        </mat-form-field>
        <mat-form-field *ngIf="componentData?.showLastName">
          <input
            matInput
            [placeholder]="'TravellerFormComponent:EnterLastNameLabel' | translate"
            readonly
            [value]="data.lastName"
          />
        </mat-form-field>
        <mat-form-field *ngIf="componentData?.isEmailRequired && (data.email !== '' || data.email !== null)">
          <input
            matInput
            formControlName="email"
            [placeholder]="'TravellerFormComponent:EnterEmailLabel' | translate"
          />

          <mat-error
            [translate]="'Form:EmailErrorMessage'"
            ngxErrors="email"
            ngxError="required"
            when="touched"
            *ngIf="profileFormGroup.get('email').hasError('required')"
          >
            Please enter email address.
          </mat-error>
          <mat-error
            [translate]="'Form:EmailErrorMessage'"
            ngxErrors="email"
            ngxError="email"
            when="touched"
            *ngIf="profileFormGroup.get('email').hasError('email')"
          >
            Please enter valid email address.
          </mat-error>
          <mat-error [translate]="'TermsPopup:RetryEmail'" *ngIf="profileFormGroup.get('email').hasError('retry')">
            Please try again.
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="componentData?.showCreditSaisonPotags" class="sso-email-error">
        <ten-notification-expandable-card
          type="info_outline"
          [resultText]="'EmailContainerComponent:SsoEmailError' | translate"
        >
        </ten-notification-expandable-card>
      </div>

      <div class="terms-container" *ngIf="needsTerms">
        <ng-container *ngIf="customisableVariables$ | async as customisableVariables">
          <p [translate]="'TermsPopup:TermsTitle'" class="pb-3 mb-0">
            You need to accept our Terms & Conditions to use the platform.
          </p>
          <mat-checkbox *ngIf="!data.tenOptIn" formControlName="ten_opt_in">
            <span [innerHTML]="customisableVariables.terms_popup_ten_opt_in"> </span>
          </mat-checkbox>
          <mat-checkbox formControlName="terms_and_conditions">
            <span
              [innerHTML]="
                customisableVariables?.terms_and_privacy_popup
                  ? (customisableVariables.terms_and_privacy_popup | translate)
                  : ('TermsPopup:Terms' | translate)
              "
            ></span>
          </mat-checkbox>
        </ng-container>
      </div>
    </form>

    <div class="button-container">
      <button
        mat-raised-button
        color="primary"
        (click)="updateProfile()"
        [disabled]="!profileFormGroup.valid || loading"
        class="submit-button"
      >
        <span *ngIf="!loading" [translate]="'TermsPopup:Continue'">Continue</span>
        <span *ngIf="loading">
          <mat-spinner diameter="30"></mat-spinner>
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="logOut()" tabindex="0">
        <span [translate]="'GlobalNav:NavLogout'"></span>
      </button>
    </div>
  </div>
</div>
